import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { Reveal, Overline } from "../Reveal";
import { WHY } from "../../data/content";

export const WhyChooseUs = ({ heading = true }) => (
  <section data-testid="why-choose-us" className="bg-white py-24 lg:py-32">
    <div className="mx-auto max-w-7xl px-5 lg:px-8">
      {heading && (
        <div className="max-w-2xl mb-14">
          <Overline>The SML Difference</Overline>
          <Reveal>
            <h2 className="mt-6 font-display text-3xl md:text-4xl lg:text-5xl tracking-tight text-sml-charcoal">
              Why Choose SML Property Solutions?
            </h2>
          </Reveal>
        </div>
      )}

      <div className="grid gap-px bg-sml-border border border-sml-border rounded-sm overflow-hidden sm:grid-cols-2 lg:grid-cols-4">
        {WHY.map((w, i) => {
          const Icon = Icons[w.icon] || Icons.CheckCircle;
          return (
            <motion.div
              key={w.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.06 }}
              className="group bg-white p-8 hover:bg-sml-forest transition-colors duration-300"
              data-testid={`why-card-${i}`}
            >
              <span className="grid place-items-center h-12 w-12 rounded-sm bg-sml-mist text-sml-forest group-hover:bg-sml-bronze group-hover:text-sml-forest transition-colors">
                <Icon className="h-6 w-6" />
              </span>
              <h3 className="mt-6 font-display text-lg text-sml-charcoal group-hover:text-white transition-colors">
                {w.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-sml-charcoal/60 group-hover:text-white/70 transition-colors">
                {w.desc}
              </p>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
